import src from "IMAGE";
export default { src, width: 1718, height: 377, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQ0lEQVR42g3KURJAIBRA0UtjmiH5KtWrPLL/NfJ/qMlIDtPpN/Yr89yFVwvDrXi7YFExvaa5HA7fE1oj/UdDIk0C7QORjwSAp2K4ugAAAABJRU5ErkJggg=="};
